module.exports = __webpack_public_path__ + "img/ico-youtube.f748341b.svg";